module.exports = __webpack_public_path__ + "img/药物分析员.3e8a0cae.jpg";